import microuniversoApi from "app/api/microuniversoApi"
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container"
import { removerBreadcrumb2 } from "app/components/breadcrumb2/breadcrumb2Utils"
import { removerComponenteReact, renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact"
import { ICampanhaDesconto } from "app/types/CupomDesconto/ICampanhaDesconto"
import pMemoize from "p-memoize"
import React from "react"
import * as R from 'ramda'
import { useEffect, useState } from "react"
import { CampanhasDeDescontosDisponiveisContainer } from "../CampanhasDeDescontosDisponiveisContainer"
import { DetalhamentoCampanhaDeDesconto } from "./DetalhamentoCampanhaDeDesconto"
import { IOrcamento } from "app/types/IOrcamento"
import { useAppSelector } from "app/redux/hooks"
import { PesquisarClienteContainer } from "app/components/pesquisa-cliente/PesquisarClienteContainer"
import globalMU from "globalMU"

export type DetalhamentoCampanhaDeDescontoContainerProps = {
  idCampanha: number;
  idCampanhas?: number[];
  onVoltarCliente: () => void;
}

export const DetalhamentoCampanhaDeDescontoContainer = (props: DetalhamentoCampanhaDeDescontoContainerProps) => {
  const orcamento: IOrcamento = useAppSelector((store) => store.orcamento)
  const [campanha, setCampanha] = useState<ICampanhaDesconto>(null)

  const onFechar = () => {
    renderizarComponentReact(<CampanhasDeDescontosDisponiveisContainer onVoltar={props.onVoltarCliente} clienteMais={orcamento.Cliente.ClienteMais} />, "conteudo-pagina",true)
  }

  const [buscarCampanhaDescontoPorIdMemoize] = useState<Function>(() => pMemoize(async (idCampanha: number): Promise<ICampanhaDesconto> => {
      /*
      return await microuniversoApi.CupomDesconto.BuscarCampanhaPorId(idCampanha)
      */
     try {
        const resposta = await microuniversoApi.CupomDesconto.BuscarCampanhaPorId(idCampanha)
        return resposta
     }
     catch (error) {
        globalMU.showErrorMessage(error.message)
        onFechar()
      }
  }))

  const atualizarCampanhaDesconto = async () => {
    const campanhaApi = await buscarCampanhaDescontoPorIdMemoize(props.idCampanha)
    setCampanha({...campanhaApi})
  }

  const onIrPrimeiraPagina = async () => {
    const campanhaApi = await buscarCampanhaDescontoPorIdMemoize(R.head(props.idCampanhas))
    setCampanha({...campanhaApi})
  }
  
  const onUltimaPagina = async () => {
    const campanhaApi = await buscarCampanhaDescontoPorIdMemoize(R.last(props.idCampanhas))
    setCampanha({...campanhaApi})
  }

  const onVoltarPagina = async () => {
    const index = R.indexOf(campanha.Id, props.idCampanhas)
    if (index > 0){
      const campanhaApi = await buscarCampanhaDescontoPorIdMemoize(props.idCampanhas[index-1])
      setCampanha({...campanhaApi})
    }
  }

  const onProximaPagina = async () => {
    const index = R.indexOf(campanha.Id, props.idCampanhas)
    if (index < props.idCampanhas.length){
      const campanhaApi = await buscarCampanhaDescontoPorIdMemoize(props.idCampanhas[index+1])
      setCampanha({...campanhaApi})
    }
  }

  useEffect(() => {
      atualizarCampanhaDesconto()
  }, [props.idCampanha])

  return <>
      <Breadcrumb2Container
        exibirBotaoLimpar={false}
        exibirBotaoVoltar={true}
        id="breadcrumb2CampanhaDesconto"
        passos={["Cadastro Cliente", "Campanha de Descontos Disponíveis", "Detalhamento da Campanha de Desconto"]}
        onBotaoVoltarClicado={() => {
            onFechar()
        }}
        onPassoSelecionado={passo => {
            if (passo == "Cadastro Cliente") {
              props.onVoltarCliente()
            }
            if (passo == "Campanha de Descontos Disponíveis") {
              onFechar()
            }
        }}/>
      {
          campanha != null &&
          <DetalhamentoCampanhaDeDesconto campanha={campanha} 
          onFechar={onFechar} 
          onIrPrimeiraPagina={onIrPrimeiraPagina}
          onVoltarPagina={onVoltarPagina}
          onProximaPagina={onProximaPagina}
          onUltimaPagina={onUltimaPagina}
          paginaAtual={R.indexOf(campanha.Id, props.idCampanhas)+1}
          totalPagina={props.idCampanhas?.length ?? 0}
          />
      }
  </>
}